module.exports = __webpack_public_path__ + "static/media/default-image.0d206907.svg";